import { render, staticRenderFns } from "./Ebook.vue?vue&type=template&id=357b167d&scoped=true"
import script from "./Ebook.vue?vue&type=script&lang=js"
export * from "./Ebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357b167d",
  null
  
)

export default component.exports